import styled from 'styled-components';
import { theme } from 'design';
import { H2 } from '../Typography';

const ModalTitle = styled(H2)`
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.semiBold};
  overflow-wrap: anywhere;
  text-align: center;
`;

export default ModalTitle;
